import { Button, Modal } from '@catering/ui';
import type { JSX } from 'react';

export interface UserResetTotpModalProps {
  fullName: string;
  submitting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * `internal-users/spec.md` → "Reseteo del segundo factor sin exponer el
 * secreto": this modal never receives nor renders a TOTP secret — it only
 * asks for explicit confirmation before `DELETE /users/:id/totp`.
 */
export function UserResetTotpModal({
  fullName,
  submitting,
  onConfirm,
  onCancel,
}: UserResetTotpModalProps): JSX.Element {
  return (
    <Modal open onClose={onCancel} title="Reiniciar verificación en dos pasos" className="max-w-md">
      <div className="flex flex-col gap-4">
        <p className="text-sm text-slate-700">
          {fullName} va a tener que volver a configurar la verificación en dos pasos la próxima vez
          que ingrese. ¿Confirmás?
        </p>

        <div className="flex items-center gap-3">
          <Button variant="destructive" loading={submitting} onClick={onConfirm}>
            Reiniciar
          </Button>
          <Button variant="secondary" onClick={onCancel}>
            Cancelar
          </Button>
        </div>
      </div>
    </Modal>
  );
}
